export default __webpack_public_path__ + "static/media/feature1.8d8cdde0.svg";